module.exports = __webpack_public_path__ + "img/check-ours.f783f783.svg";